export const mapConfig = {
  apiGoogle: "AIzaSyDi57TR28EgtNgyoMERvvQ0SLIg4YHjIBY",
};

export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;
